
import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import * as actions from '../../actionTypes'
import {getCookie, setCookie} from '../../utils'


/**
 * Manages several session related tasks.
 * - Validates current session status.
 * - Schedules refresh cookie to heuristically determine page refresh vs. tab/window close.
 */
export class SessionSupervisor extends Component {

  constructor(props) {
    super(props)
    this.state = {isPageRefresh: this.isPageRefresh()}
    this.authorizeSession()
    this.scheduleRefreshCookie()
  }

  authorizeSession() {
    if(!this.state.isPageRefresh) {
      // clear server session and redirect to login
      this.props.implicitlyLogout()
    }
    this.props.checkSessionStatus()
  }

  isPageRefresh() {
    return !!getCookie(this.props.refreshKey)
  }

  scheduleRefreshCookie() {
    window.onbeforeunload = () => {
      setCookie(this.props.refreshKey, '1', this.props.refreshTTL)
    }
  }

  render() {
    return null
  }
}

const mapDispatchToProps = dispatch => ({
  checkSessionStatus() {
    const action = {type: actions.CHECK_SESSION_STATUS}
    dispatch(action)
  },
  // implicit because user does not trigger this action
  implicitlyLogout() {
    const action = {type: actions.LOGOUT_REQUESTED}
    dispatch(action)
  }
})

SessionSupervisor.defaultProps = {
  refreshKey: '_refresh'
}

SessionSupervisor.propTypes = {
  refreshKey: PropTypes.string,
  refreshTTL: PropTypes.number.isRequired // TTL in minutes
}

export default connect(
  null, mapDispatchToProps
)(SessionSupervisor)


// WEBPACK FOOTER //
// ./src/components/counseling-session/SessionSupervisor.js